// ----------------------------------------------------------------------
// <copyright file="Izenda.PopupButton.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * PopupButton component
 */
!(function() {
  var React = require('react');

  var Button = require('share/components/controls/Izenda.Button');
  var OperatorValueCheckBoxPopup = require('./Izenda.OperatorValueCheckBoxPopup');
  var OperatorValueCheckBoxPopupLazyLoading = require('./Izenda.OperatorValueCheckBoxPopupLazyLoading');
  var connect = require('share/enhancers/Izenda.Connect');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  const { isNil, flow, identity, isEmpty, map, join, filter } = require('lodash/fp');

  var PopupButton = React.createClass({
    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      applyFormater: React.PropTypes.func
    },
    getDefaultProps: function() {
      return {
        applyFormater: identity
      };
    },

    handleShowPopup: function() {
      var Component = this.props.isLazyLoading ? OperatorValueCheckBoxPopupLazyLoading : OperatorValueCheckBoxPopup;
      this.props.openPopup(Component, this.props);
    },

    render: function() {
      var props = this.props;
      var filterValues = props.filterInfo.value;
      var applyFormater = this.props.applyFormater;
      var value = flow(
        filter(function(item) {
          return !isEmpty(item);
        }),
        map(applyFormater),
        join(', ')
      )(filterValues);

      return (
        <div>
          <Button disabled={props.disabled} label="..." onClick={this.handleShowPopup} className="btn-popup" />
          <div className="filter-value">
            <ScrollBox autoHeight autoHeightMax={150}>
              {value}
            </ScrollBox>
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(PopupButton);
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.PopupButton.jsx